<script setup lang="ts">
import { FolderOpen, Home, Users } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

import SidebarNavItem from '@components/atoms/SidebarNavItem.vue';
import { useSidebar } from '@composables/useSidebar';

const { t } = useI18n();
const { isCollapsed } = useSidebar();
</script>

<template>
  <nav class="flex flex-col gap-4 px-3">
    <!-- Section: Asosiy -->
    <div class="flex flex-col gap-1">
      <span
        v-if="!isCollapsed"
        class="text-muted-foreground/70 px-3 py-1 text-[11px] font-semibold tracking-wider uppercase"
      >
        {{ t('sidebar.sections.main') }}
      </span>

      <SidebarNavItem to="/" :label="t('sidebar.dashboard')" exact>
        <template #icon>
          <Home />
        </template>
      </SidebarNavItem>
    </div>

    <!-- Section: Ma'lumotlar -->
    <div class="flex flex-col gap-1">
      <span
        v-if="!isCollapsed"
        class="text-muted-foreground/70 px-3 py-1 text-[11px] font-semibold tracking-wider uppercase"
      >
        {{ t('sidebar.sections.data') }}
      </span>

      <SidebarNavItem to="/projects" :label="t('sidebar.projects')">
        <template #icon>
          <FolderOpen />
        </template>
      </SidebarNavItem>

      <SidebarNavItem to="/contractors" :label="t('sidebar.contractors')">
        <template #icon>
          <Users />
        </template>
      </SidebarNavItem>
    </div>
  </nav>
</template>
